
// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

new Swiper(".sp-swiper2", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  slidesPerView: 2,
  slidesPerGroup: 1, // 几个slides为一组
  spaceBetween: 11,
  loop: true,
  pagination: {
    el: ".sp-pagination1",
    type: "bullets",
    clickable: true,
  },
});

var thumbsp = new Swiper("#thumbs-p", {
  direction: "vertical",
  spaceBetween: 12,
  slidesPerView: 4.8,
  watchSlidesVisibility: true, //防止不可点击
});
let swiper = new Swiper("#swiper-p1", {
  thumbs: {
    swiper: thumbsp,
  },
  on: {
    slideChange: function (e) {
      $("#sp-color .option")
        .eq(e.activeIndex == 0 ? e.activeIndex : e.activeIndex - 1)
        .addClass("active")
        .siblings()
        .removeClass("active");
    },
  },
  spaceBetween: 20,
});
let spImgList = [
  "https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-01.gif",
  "https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-p1.webp",
  "https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-p2.webp",
  "https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-p3.webp",
  "https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-p4.webp",
  "https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-p5.webp",
  "https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-b1.webp",
  "https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-b2.webp",
  "https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-b3.webp",
  "https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-b4.webp",
  "https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-b5.webp",
];

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            262 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();
  $(".choose-btn").click(function () {
        $(this).addClass("active").siblings().removeClass("active");
        if($('.choose-btn.active').index() == 0){
            $(".box1").css('display','block');
            $(".box2").css('display','none');
        }else{
            $(".box2").css('display','block');
            $(".box1").css('display','none');
        }
      });
 $(".select").click(function () {
        $(".optList").not($(this).siblings(".optList")).hide();
        $(this).siblings(".optList").toggle();
      });

   var imgList = {
        "Lmprimé léopard":'https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-p1.png',
        "Bleu":'https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-p2.webp?v=1722306141',
        "Vert":'https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-p3.png',
        "Orange":'https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-p4.webp',
        "Rose":'https://cdn.shopifycdn.net/s/files/1/0618/0061/1913/files/20240725-p5.png',
      };

      $(".opt").click(function () {
        let text = $(this).children().html();
        $(this).parent(".optList").hide();
        $(this).parent().siblings(".select").children(".font2").html(text);
        $(this).addClass("picked").siblings().removeClass("picked");
        if ($(this).parent().hasClass("color1")) {
          $("#p1 img").attr("src", imgList[text]);
        }
        if ($(this).parent().hasClass("color2")) {
          $("#p2 img").attr("src", imgList[text]);
        }
        $(".optList").not($(this).siblings(".optList")).hide();
        $(this).siblings(".optList").toggle();
      });

  $( document ).on( 'click', '.btn-quantity', function() {
            var inputDom = $( this ).siblings( 'input[type="number"]' )
            var inputVal = inputDom.val()
            if( $( this ).hasClass( 'btn-quantity-plus' ) ) {
              inputVal = parseInt( inputVal ) + 1
            }
            else {
              inputVal = parseInt( inputVal ) - 1
            }
            if(inputVal < 1){
                inputVal = 1
            }
            inputDom.val(inputVal).change()
        })
     let prods = window.product
console.log(prods,'prods')
      var skuList = [
        [prods[0].id,prods[1].id,prods[2].id,prods[3].id,prods[4].id,prods[5].id,prods[6].id],
        [prods[7].id,prods[8].id,prods[9].id,prods[10].id,prods[11].id,prods[12].id,prods[13].id],
        [prods[14].id,prods[15].id,prods[16].id,prods[17].id,prods[18].id,prods[19].id,prods[20].id],
        [prods[21].id,prods[22].id,prods[23].id,prods[24].id,prods[25].id,prods[26].id,prods[27].id],
        [prods[28].id,prods[29].id,prods[30].id,prods[31].id,prods[32].id,prods[33].id,prods[34].id]
      ];


      
      function atc(val){
          if(val == 2){
               let formData = {
               'items': [{
                'id': skuList[$('.optList.opi2 .picked').index()][$('.optList.opi3 .picked').index()],
                'quantity': $('input#qty2').val()
                },{
                'id': skuList[$('.optList.opi4 .picked').index()][$('.optList.opi5 .picked').index()],
                'quantity': $('input#qty2').val()
                }]
              };
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
              .then(response => {
                 $.getJSON(window.Shopify.routes.root + 'cart.js',function(result){
                  $('#cardNum').html(result.item_count)
                  })
                return response.json();
              })
              .catch((error) => {
                console.error('Error:', error);
              });
          }
      }

  function emitCheckout(val){
        if(val == 2){
           window.location.href = '/cart/' + skuList[$('.optList.opi2 .picked').index()][$('.optList.opi3 .picked').index()] + ':' + $('input#qty2').val() + ',' + 
            skuList[$('.optList.opi4 .picked').index()][$('.optList.opi5 .picked').index()] + ':' + $('input#qty2').val()
        }
      }

// let sp_price1 = 32.99;
// let sp_price2 = 65.98;

// function calcTotal(price, num) {
//   let result = Number(price) * Number(num);
//   return result.toFixed(2);
// }
   // 数字框
    // let prods = window.product
console.log(prods,'prods')
    function getCur(){
      let color = $('#sp-color div.active').attr('data-val')
      let size = $('#sp-size div.active').attr('data-val')
      return prods.filter(item=> item.option1 == color && item.option2 == size)[0]
    }
    function changePrice(){
      let num = $('#calcNumber').val()
      let price = (getCur().price * num / 100).toFixed(2)
      let compare = (getCur().compare_at_price * num / 100).toFixed(2)
      price = (price + '').replace('.', ',')
      compare = (compare + '').replace('.', ',')
      $('#sp_price1').html(price)
      $('#sp_price2').html(compare)
      let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      $(".off_box span").html(off_font);
    }
    $('.buyNow').click(function(){
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })

$(".sp-reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
    changePrice()
  }
  // $("#sp_price1").html(calcTotal(sp_price1, input.value));
  // $("#sp_price2").html(calcTotal(sp_price2, input.value));
});
$(".sp-add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
   changePrice()
  // $("#sp_price1").html(calcTotal(sp_price1, input.value));
  // $("#sp_price2").html(calcTotal(sp_price2, input.value));
});

// 弹窗内尺码表切换
$(".sp-size-part2 .btn-wrap").click(function () {
  $(this).addClass("active").siblings().removeClass("active");
  let index = $(this).index();
  $(".sp-size-part2 .sp-size1").eq(index).show().siblings(".sp-size1").hide();
});

// 商品弹窗状态
let _popShow = false;

// 展示尺码弹窗
$(".sp-size-btn").click(function () {
  $(".sp-mask").css("display", "flex");
  $(".sp-mask .size-pop").show();
  $(".sp-mask .img-pop").hide();
});

// 点击放大按钮
$(".sp-large,.p-img").click(function () {
  $(".sp-mask").css("display", "flex");
  let _index = $("#sp-color .active").index();

  $(".sp-mask .img-pop .sp-img")[0].src = $(
    ".product-part .sp-swiper .swiper-slide-active .sp-img"
  )[0].src;
  $(".sp-mask .img-pop").css("display", "flex");
  $(".sp-mask .size-pop").hide();
});
// 关闭弹窗按钮

$(".sp-mask").click(function (e) {
  if ($(e.target).closest(".sp-mask .choose-btn").length > 0) {
  } else {
    $(".sp-mask").hide();
  }
});
$(function () {
  $(".option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    // style选项

    let colorOptions = $("#sp-color .option.active").index();
    if (colorOptions == 0) {
      swiper.slideTo(colorOptions);
    } else {
      swiper.slideTo(colorOptions + 1);
    }
  });

  // style选项
  // // 处理加入购物车事件
  // function handleAddToCart(num) {
  //   if (num > 0) {
  //     $("#cardNum").html(num).show();
  //     $(".sp-top-btn").addClass("sp-high");
  //     $(".sp-top-btn span").html("Check out");
  //     $(".sp-header-top .sp-cart").addClass("on");
  //   } else {
  //     $("#cardNum").html(0).hide();

  //     $(".sp-top-btn").removeClass("sp-high");
  //     $(".sp-top-btn span").html("Buy now");
  //     $(".sp-header-top .sp-cart").removeClass("on");
  //   }
  // }
  // handleAddToCart(0);

  // 购物车加购动效
  $(".cart-btn").click(function () {
    $(this).children("img").addClass("on");
    $(".sp-header-top .sp-cart .num").show();
    setTimeout(function () {
      $(".cart-btn").children("img").removeClass("on");
    }, 500);
    $(".sp-header-top .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-header-top .sp-cart").removeClass("on");
    }, 500);
  });
  let initNum = 0;
  $(".product-part .cart-btn").click(function () {
    // let spNum = $(".product-part #calcNumber")[0].value;
    // initNum += Number(spNum);

    // $("#calcNumber").val(1);
    // $("#cardNum").html(initNum);
    // // handleAddToCart(initNum);
      var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $("#cardNum").html(result.item_count);
          });
        },
        dataType: "json",
      });

    // var img = $(".product-part .p-img");
    var img = $(".product-part .sp-swiper .swiper-slide-active .sp-img");

    var flyer = img[0].cloneNode(true);
    flyer.classList.add("sp_clone");

    $(".product-part").append(flyer);
    $(".sp_clone").css({
      width: img[0].width,
      height: img[0].height,
      background: "#e7e9ef",
      position: "fixed",
      top: img[0].offsetTop,
      left: img.offset().left,
      "z-index": "99",
    });

    let finish = $(".sp-cart");
    $(".sp_clone").animate(
      {
        top: finish[0].offsetTop + finish.height() / 2 + $('.time-part').height(),
        left: finish[0].offsetLeft + finish.width() / 2,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      500,
      "linear",
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach();
          }
        );
      }
    );
  });
});
